module.exports = __webpack_public_path__ + "img/校园.17c9e991.gif";